import React, {lazy, Suspense} from "react";
import {Box, Flex, Heading, HStack, Text, useMediaQuery, VStack,} from "@chakra-ui/react";
import bannerBackground from '../../assets/images/banner_background.png';
import bannerBackgroundMobile from '../../assets/images/mobile/banner_background_mobile.png';
import {StyledButton} from "../../components";
import {ReactComponent as TelegramIcon} from "../../assets/icons/telgramIconWhite.svg";
import {ReactComponent as XIcon} from "../../assets/icons/xIconWhite.svg";
import {ReactComponent as LinkedinIcon} from "../../assets/icons/linkedInIconWhite.svg";
import {Link} from "react-router-dom";

const Cards = lazy(() => import("./parts/Cards"));
const Earnings = lazy(() => import("./parts/Earnings"));
const Steps = lazy(() => import("./parts/Steps"));
const ProfitsCarousel = lazy(() => import("./parts/ProfitsCarousel"));
const ReferEarn = lazy(() => import("./parts/ReferEarn"));
const ExchangesCarousel = lazy(() => import("./parts/ExchangesCarousel"));

const HomePage = () => {
    const [isMobile] = useMediaQuery("(max-width: 1270px)")

    return (
        <Box overflow={'hidden'}>
            <Box
                height={{lg: '744px'}}
                position={'relative'}
                zIndex={'10'}
                as={'section'}>
                <VStack
                    gap={'0'}
                    margin={'auto'}
                    alignItems={'start'}
                    px={{base: '16px'}}
                    justifyContent={'center'}
                    maxW={'xl'}>
                    <Heading
                        marginTop={'160px'}
                        maxW={'794px'}
                        fontWeight={'500'}
                        lineHeight={{base: '28px',lg: '76px'}}
                        zIndex={"99"}
                        fontSize={{base: 'heading.3xl',lg: 'display.xl'}}
                        color={'neutral.100'}>
                        Turn Market Inefficiencies Into Profit – Trade Smarter, Not Harder
                    </Heading>
                    <Text
                        maxW={'517px'}
                        mt={'24px'}
                        lineHeight={{base:'19px'}}
                        fontWeight={'400'}
                        fontSize={{base: 'body.md',lg: 'heading.3xl'}}
                        bgClip="text"
                        bgGradient="linear-gradient(90deg, #B092FF 0%, #999999 100%)">
                        Seamlessly track spreads, maximize profits, and stay ahead of the game
                    </Text>
                    <HStack
                        flexDirection={{base: 'column', lg: 'row'}}
                        w={'full'}
                        mt={'64px'}
                        gap={'24px'}>
                        <StyledButton
                            maxW={'265px'}
                            as={Link}
                            to={'/early-access'}
                            w={{base: 'full',lg: '186px'}}
                            h={{base: '40px',lg: '56px'}}>
                            Get Early Access
                        </StyledButton>
                        <StyledButton
                            maxW={'265px'}
                            w={{base: 'full',lg: '139px'}}
                            h={{base: '35px',lg: '56px'}}>
                            Learn More
                        </StyledButton>
                    </HStack>
                </VStack>
                <Box
                    w={{base: '343px',lg: '1075px'}}
                    position={'absolute'}
                    transform={'translate(-50%), -50%'}
                    right={'16px'}
                    top={'15px'}
                    zIndex={'10'}
                    height={'100%'}
                    background={{base: `url(${bannerBackgroundMobile})`, lg: `url(${bannerBackground})`}}
                    backgroundSize={{base: '',lg: 'cover'}}
                    backgroundRepeat={'no-repeat'}/>
            </Box>
            <Box
                h={{lg: '339px'}}
                mt={{base:'48px'}}
                textAlign={'center'}
                mb={{base:'48px', lg: '248px'}}>
                <Heading
                    color={'white'}
                    fontSize={{base: 'heading.3xl',lg: 'display.md'}}>
                    Supported Exchanges & Networks
                </Heading>
                <ExchangesCarousel />
                <Box px={'16px'}>
                    <StyledButton
                        maxW={'265px'}
                        w={{base: 'full',lg: '290px'}}
                        h={{base: '40px',lg :'56px'}}>
                        Explore Supported Exchanges
                    </StyledButton>
                </Box>
            </Box>
            <Flex
                flexDirection={'column'}
                gap={{base: '32px',lg: '48px'}}
                minH={'792px'}
                textAlign={'center'}
                px={'16px'}
                maxW={'xl'}
                m={'auto'}>
                <Heading color={'white'} fontSize={{base: 'heading.3xl',lg: 'display.md'}}>All-in-One Arbitrage Suite</Heading>
                <Suspense fallback={<div>Loading...</div>}>
                    <Cards />
                </Suspense>
            </Flex>
            <Flex
                pt={'160px'}
                flexDirection={'column'}
                px={'16px'}
                gap={{base: '32px',lg: '48px'}}
                textAlign={'center'}
                className={'main-container'}>
                <Heading
                    color={'white'}
                    fontSize={{base: 'heading.3xl',lg: 'display.md'}}>
                    Discover Your Potential Earnings
                </Heading>
                <Suspense fallback={<div>Loading...</div>}>
                    <Earnings />
                </Suspense>
            </Flex>
            <Box
                pt={'160px'}
                gap={{base: '32px',lg: '48px'}}
                px={'16px'}
                textAlign={'center'}
                className={'main-container'}>
                <Heading
                    color={'white'}
                    fontSize={{base: 'heading.3xl',lg: 'display.md'}}
                    pb={'48px'}>
                    How It Works – Arbitrage in 4 Simple Steps
                </Heading>
                <Suspense fallback={<div>Loading...</div>}>
                    <Steps />
                </Suspense>
                {!isMobile &&  <StyledButton
                    width={'141px'}
                    height={'56px'}>
                    Get Started
                </StyledButton>}
            </Box>
            <Box
                py={'80px'}
                gap={{base: '32px',lg: '48px'}}
                px={'16px'}
                maxH={'755px'}
                h={'755px'}
                textAlign={'center'}>
                <Heading
                    color={'white'}
                    className={'main-container'}
                    fontSize={{base: 'heading.3xl',lg: 'display.md'}}
                    pb={'48px'}>
                    Case Studies – Real Profits from Real Opportunities
                </Heading>
                <Suspense fallback={<div>Loading...</div>}>
                    <ProfitsCarousel />
                </Suspense>
            </Box>
            <Box
                py={'80px'}
                px={'16px'}>
                <Suspense fallback={<div>Loading...</div>}>
                    <ReferEarn />
                </Suspense>
            </Box>
            <VStack
                color={'white'}
                textAlign={'center'}
                // mt={{base: '0',lg: '330px'}}
            >
                <Heading
                    fontSize={{base: 'heading.3xl',md: 'display.md',lg: 'display.md'}}
                    mb={{base: '24px',lg: '48px'}}>
                    Join us
                </Heading>
                <HStack gap={'70px'}>
                    <VStack>
                        <TelegramIcon />
                        <Text>Telegram</Text>
                    </VStack>
                    <VStack>
                        <XIcon />
                        <Text>X</Text>
                    </VStack>
                    <VStack>
                        <LinkedinIcon />
                        <Text>LinkedIn</Text>
                    </VStack>
                </HStack>
            </VStack>
        </Box>

    )
}

export default HomePage